import React from "react";
import { GroupQueueSectionProps } from "../types/types";
import { Form } from "@components";
import { Box } from "@material-ui/core";
import { Warning as WarningIcon } from "@material-ui/icons";
import { FORM_LABELS } from "../constants/constants";

export const GroupQueueAssignmentSection: React.FC<GroupQueueSectionProps> = ({
  form,
  onFormValueChange,
  sectionNumber,
  language = "EN",
  extended = false,
}) => {
  const LABELS = FORM_LABELS[language];

  return (
    <>
      {" "}
      <Form.Title>{`${sectionNumber} - ${LABELS.GROUP_ASSIGNMENT.FORM_TITLE}`}</Form.Title>
      <Form.Text color="warning.main">
        <Box display="flex">
          <WarningIcon />
          <Box pl={1} pt={0.5}>
            {LABELS.GROUP_ASSIGNMENT.FORM_NOTE}{" "}
            {/* <a href={PERSONA_SHEET_LINK} target="_blank" rel="noreferrer">
              AP Persona sheet.
            </a> */}
          </Box>
        </Box>
      </Form.Text>
      {!extended ? (
        <>
          <Form.Textbox
            label="1"
            name="assign1"
            onChange={onFormValueChange}
            size={6}
            value={form.values.assign1}
          />
          <Form.Textbox
            label="6"
            name="assign6"
            onChange={onFormValueChange}
            size={6}
            value={form.values.assign6}
          />
          <Form.Textbox
            label="2"
            name="assign2"
            onChange={onFormValueChange}
            size={6}
            value={form.values.assign2}
          />
          <Form.Textbox
            label="7"
            name="assign7"
            onChange={onFormValueChange}
            size={6}
            value={form.values.assign7}
          />
          <Form.Textbox
            label="3"
            name="assign3"
            onChange={onFormValueChange}
            size={6}
            value={form.values.assign3}
          />
          <Form.Textbox
            label="8"
            name="assign8"
            onChange={onFormValueChange}
            size={6}
            value={form.values.assign8}
          />
          <Form.Textbox
            label="4"
            name="assign4"
            onChange={onFormValueChange}
            size={6}
            value={form.values.assign4}
          />
          <Form.Textbox
            label="9"
            name="assign9"
            onChange={onFormValueChange}
            size={6}
            value={form.values.assign9}
          />
          <Form.Textbox
            label="5"
            name="assign5"
            onChange={onFormValueChange}
            size={6}
            value={form.values.assign5}
          />
          <Form.Textbox
            label="10"
            name="assign10"
            onChange={onFormValueChange}
            size={6}
            value={form.values.assign10}
          />
        </>
      ) : (
        <>
          <Form.Textbox
            label="1"
            name="assign1"
            onChange={onFormValueChange}
            size={6}
            value={form.values.assign1}
          />
          <Form.Textbox
            label="16"
            name="assign16"
            onChange={onFormValueChange}
            size={6}
            value={form.values.assign16}
          />
          <Form.Textbox
            label="2"
            name="assign2"
            onChange={onFormValueChange}
            size={6}
            value={form.values.assign2}
          />
          <Form.Textbox
            label="17"
            name="assign17"
            onChange={onFormValueChange}
            size={6}
            value={form.values.assign17}
          />
          <Form.Textbox
            label="3"
            name="assign3"
            onChange={onFormValueChange}
            size={6}
            value={form.values.assign3}
          />
          <Form.Textbox
            label="18"
            name="assign18"
            onChange={onFormValueChange}
            size={6}
            value={form.values.assign18}
          />
          <Form.Textbox
            label="4"
            name="assign4"
            onChange={onFormValueChange}
            size={6}
            value={form.values.assign4}
          />
          <Form.Textbox
            label="19"
            name="assign19"
            onChange={onFormValueChange}
            size={6}
            value={form.values.assign19}
          />
          <Form.Textbox
            label="5"
            name="assign5"
            onChange={onFormValueChange}
            size={6}
            value={form.values.assign5}
          />
          <Form.Textbox
            label="20"
            name="assign20"
            onChange={onFormValueChange}
            size={6}
            value={form.values.assign20}
          />
          <Form.Textbox
            label="6"
            name="assign6"
            onChange={onFormValueChange}
            size={6}
            value={form.values.assign6}
          />
          <Form.Textbox
            label="21"
            name="assign21"
            onChange={onFormValueChange}
            size={6}
            value={form.values.assign21}
          />
          <Form.Textbox
            label="7"
            name="assign7"
            onChange={onFormValueChange}
            size={6}
            value={form.values.assign7}
          />
          <Form.Textbox
            label="22"
            name="assign22"
            onChange={onFormValueChange}
            size={6}
            value={form.values.assign22}
          />
          <Form.Textbox
            label="8"
            name="assign8"
            onChange={onFormValueChange}
            size={6}
            value={form.values.assign8}
          />
          <Form.Textbox
            label="23"
            name="assign23"
            onChange={onFormValueChange}
            size={6}
            value={form.values.assign23}
          />
          <Form.Textbox
            label="9"
            name="assign9"
            onChange={onFormValueChange}
            size={6}
            value={form.values.assign9}
          />
          <Form.Textbox
            label="24"
            name="assign24"
            onChange={onFormValueChange}
            size={6}
            value={form.values.assign24}
          />
          <Form.Textbox
            label="10"
            name="assign10"
            onChange={onFormValueChange}
            size={6}
            value={form.values.assign10}
          />
          <Form.Textbox
            label="25"
            name="assign25"
            onChange={onFormValueChange}
            size={6}
            value={form.values.assign25}
          />
          <Form.Textbox
            label="11"
            name="assign11"
            onChange={onFormValueChange}
            size={6}
            value={form.values.assign11}
          />
          <Form.Textbox
            label="26"
            name="assign26"
            onChange={onFormValueChange}
            size={6}
            value={form.values.assign26}
          />
          <Form.Textbox
            label="12"
            name="assign12"
            onChange={onFormValueChange}
            size={6}
            value={form.values.assign12}
          />
          <Form.Textbox
            label="27"
            name="assign27"
            onChange={onFormValueChange}
            size={6}
            value={form.values.assign27}
          />
          <Form.Textbox
            label="13"
            name="assign13"
            onChange={onFormValueChange}
            size={6}
            value={form.values.assign13}
          />
          <Form.Textbox
            label="28"
            name="assign28"
            onChange={onFormValueChange}
            size={6}
            value={form.values.assign28}
          />

          <Form.Textbox
            label="14"
            name="assign14"
            onChange={onFormValueChange}
            size={6}
            value={form.values.assign14}
          />
          <Form.Textbox
            label="29"
            name="assign29"
            onChange={onFormValueChange}
            size={6}
            value={form.values.assign29}
          />
          <Form.Textbox
            label="15"
            name="assign15"
            onChange={onFormValueChange}
            size={6}
            value={form.values.assign15}
          />
          <Form.Textbox
            label="30"
            name="assign30"
            onChange={onFormValueChange}
            size={6}
            value={form.values.assign30}
          />
        </>
      )}
    </>
  );
};

//TODO: add additional queues for Marketing region
